import {
  SCORE_KEYS,
  scoreBgStyle,
  scoreBgVar,
  scoreColorStyle,
  scoreColorVar,
  type ScoreKey,
  type SubScores,
} from "@vidario/domain";
import { Briefcase, Building, CheckCircle, MapPin, type LucideIcon } from "lucide-react";

/** UI-side metadata for each score dimension — pairs the domain's
 * {@link ScoreKey} with the icon + German label that goes next to it.
 * Score keys and color helpers live in @vidario/domain (runtime-agnostic);
 * the icon + label live here because they are React/Lucide-specific. */
export const SCORE_DIMENSIONS: readonly { key: ScoreKey; label: string; icon: LucideIcon }[] = [
  { key: "skills", label: "Anforderungen", icon: CheckCircle },
  { key: "experience", label: "Erfahrung", icon: Briefcase },
  { key: "industry", label: "Branche", icon: Building },
  { key: "location", label: "Standort", icon: MapPin },
];

export type ScoreDimension = (typeof SCORE_DIMENSIONS)[number];
export type IconComponent = LucideIcon;

export type { ScoreKey, SubScores };
export { SCORE_KEYS, scoreBgStyle, scoreBgVar, scoreColorStyle, scoreColorVar };
